import React from 'react';

import styles from './guide-animation.module.scss';

const List = ({ data }) => {
  return (
    <ul className={styles.list}>
      {data &&
        data.rows &&
        data.rows.map((item) => (
          <li key={`${item.headline}--${item.text}`} className={styles.listItem}>
            <div className={styles.headline}>{item.headline}</div>
            <div className={styles.text}>{item.text}</div>
          </li>
        ))}
    </ul>
  );
};

export { List };
